import axiosClient from "../utils/axiosClient";

export const getPartnerDetails = () => axiosClient.get("/getpartnerdetails");

export const updatePartnerDetails = (updatedData) =>
  axiosClient.put("/updatePartnerDetails", updatedData);

export const postRequirements = (data) =>
  axiosClient.post("/postrequirements", data);

export const postSocialDetails = (partnerId, socialData) =>
  axiosClient.post(`/socialdetails/${partnerId}`, socialData);
export const editSocialDetails = (partnerId, socialData) =>
  axiosClient.post(`/editsocialdetails/${partnerId}`, socialData);

export const setUserLocation = (partnerId, locationData) =>
  axiosClient.post(`/setlocation/${partnerId}`, locationData);
export const updateUserLocation = (partnerId, locationData) =>
  axiosClient.put(`/updatelocation/${partnerId}`, locationData);

// Equipments
export const getAllEquipments = (partnerId) =>
  axiosClient.get(`/equipments/${partnerId}`);

export const addEquipment = (partnerId, equipment) =>
  axiosClient.post(`/equipments/${partnerId}`, equipment);

export const removeEquipment = (partnerId, equipmentId) =>
  axiosClient.delete(`/equipments/${partnerId}/${equipmentId}`);

export const getAllEquipmentTypes = () =>
  axiosClient.get("/equipments/equipmenttypes");

export const updateEquipment = (equipmentId, payload) =>
  axiosClient.put(`/equipments/${equipmentId}`, payload);

// training data
export const getAllTrainingCourses = async () =>
  axiosClient.get("/training-programs");

export const enrollTraining = (partnerId, programId) =>
  axiosClient.post(`/training-programs/${partnerId}/${programId}`);

// Certificates
export const fetchAllCertificates = (partnerId) =>
  axiosClient.get(`/certificates/${partnerId}`);
export const fetchKycDocument = (partnerId) =>
  axiosClient.get(`/kyc/${partnerId}`);
export const deleteKycDocument = (partnerId, kycId) =>
  axiosClient.delete(`/kyc/${partnerId}/${kycId}`);

export const addCertificate = (partnerId, certificate) =>
  axiosClient.post(`/certificates/${partnerId}`, certificate);

export const deleteCertificate = (partnerId, certificateId) =>
  axiosClient.delete(`/certificates/${partnerId}/${certificateId}`);

export const updateCertificate = (certificateId, certificate) => {
  console.log("Sending to API:", { certificateId, certificate });
  axiosClient.put(`/certificates/${certificateId}`, certificate);
};

// Licence
export const fetchAllLicence = (partnerId) =>
  axiosClient.get(`/licence/${partnerId}`);

export const addLicence = (partnerId, licence) =>
  axiosClient.post(`/licence/${partnerId}`, licence);

export const removeLicence = (partnerId, licenceId) =>
  axiosClient.delete(`/licence/${partnerId}/${licenceId}`);

export const updateLicence = (licenceId, licence) => {
  axiosClient.put(`/licence/${licenceId}`, licence);
};

// Service
export const fetchAllService = (partnerId) =>
  axiosClient.get(`/services/${partnerId}`);
export const fetchServiceCategory = () =>
  axiosClient.get(`/services/categories`);
export const fetchServiceKeywords = () =>
  axiosClient.get(`/services/keywords/`);

export const createNewService = (partnerId, service) =>
  axiosClient.post(`/services/${partnerId}`, service);
export const removeService = (partnerId, serviceId) =>
  axiosClient.delete(`/services/${partnerId}/${serviceId}`);
export const fetchServiceById = (partnerId, serviceId) =>
  axiosClient.get(`/services/${partnerId}/${serviceId}`);

// experience
export const fetchAllExperience = (partnerId) =>
  axiosClient.get(`/experience/${partnerId}`);
export const addNewExperience = (partnerId, experience) =>
  axiosClient.post(`/experience/${partnerId}`, experience);
export const removeExperience = (partnerId, experienceId) =>
  axiosClient.delete(`/experience/${partnerId}/${experienceId}`);

// Kyc
export const submitKycData = (partnerId, kycData) =>
  axiosClient.post(`/kyc/${partnerId}`, kycData);
